import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Group, List, ScrollArea, Spoiler, Text } from '@coveord/plasma-mantine';
import { Locales } from '../../strings/Locales.js';
import { DeletePromptList } from './delete/DeletePromptList.js';
import classes from './ProjectsList.module.css';
var VISIBLE_COUNT = 5;
var ProjectListItem = function ProjectListItem(param) {
    var project = param.project;
    var name = project.name, createdFrom = project.createdFrom;
    var createdFromDescriptor = createdFrom && Locales.formatOrDefault("ProjectsList.listItem.descriptor.".concat(createdFrom), {
        defaultTranslation: Locales.format('ProjectsList.listItem.descriptor.default')
    });
    return /*#__PURE__*/ _jsx(List.Item, {
        children: /*#__PURE__*/ _jsxs(Group, {
            gap: "xxs",
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    fw: 500,
                    children: name
                }),
                createdFromDescriptor && /*#__PURE__*/ _jsx(Text, {
                    c: "dimmed",
                    children: createdFromDescriptor
                })
            ]
        })
    });
};
export var ProjectsList = function ProjectsList(param) {
    var items = param.items;
    var visibleProjects = items.slice(0, VISIBLE_COUNT);
    var hiddenProjects = items.slice(VISIBLE_COUNT);
    return /*#__PURE__*/ _jsxs(ScrollArea.Autosize, {
        mah: 240,
        children: [
            /*#__PURE__*/ _jsx(DeletePromptList, {
                children: visibleProjects.map(function(project, ix) {
                    var _project_id;
                    return /*#__PURE__*/ _jsx(ProjectListItem, {
                        project: project
                    }, (_project_id = project.id) !== null && _project_id !== void 0 ? _project_id : "visible-project-".concat(ix));
                })
            }),
            hiddenProjects.length > 0 && /*#__PURE__*/ _jsx(Spoiler, {
                maxHeight: 0,
                showLabel: Locales.format('ProjectsList.spoiler.showLabel', {
                    count: hiddenProjects.length,
                    smart_count: hiddenProjects.length
                }),
                hideLabel: null,
                classNames: {
                    control: classes.control
                },
                children: /*#__PURE__*/ _jsx(DeletePromptList, {
                    children: hiddenProjects.map(function(project, ix) {
                        var _project_id;
                        return /*#__PURE__*/ _jsx(ProjectListItem, {
                            project: project
                        }, (_project_id = project.id) !== null && _project_id !== void 0 ? _project_id : "hidden-project-".concat(ix));
                    })
                })
            })
        ]
    });
};

//# sourceMappingURL=ProjectsList.js.map